import { Flag, AlertTriangle, Plus } from 'lucide-react';
import { format } from 'date-fns';

/**
 * Desktop flags strip for the Schedule week: people with no job this week and
 * people on two different jobs the same day. `onAddFor(personId)` opens Add.
 */
export function ScheduleFlagsCard({ flags, teamLabel, onAddFor }) {
  const { unscheduled, doubleBooked } = flags;
  if (unscheduled.length === 0 && doubleBooked.length === 0) return null;
  return (
    <div className="mb-4 rounded-lg border border-amber-500/30 bg-[#2A3240] p-4 grid gap-4 md:grid-cols-2" data-testid="schedule-flags-card">
      {unscheduled.length > 0 && (
        <div data-testid="unscheduled-panel">
          <div className="flex items-center gap-2">
            <Flag className="w-4 h-4 text-amber-400" />
            <span className="text-white font-semibold text-sm">Not scheduled this week</span>
            <span className="text-xs px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-300 border border-amber-500/30" data-testid="unscheduled-count">{unscheduled.length}</span>
          </div>
          <p className="text-xs text-gray-400 mt-1">{teamLabel} with no job on any project this week — click a name to add them.</p>
          <div className="flex flex-wrap gap-2 mt-3">
            {unscheduled.map(p => (
              <button key={p.id} type="button" onClick={() => onAddFor?.(p.id)} className="text-xs font-semibold px-3 py-1.5 rounded-full bg-amber-500/15 text-amber-200 border border-amber-500/30 hover:bg-amber-500/25 transition-colors inline-flex items-center gap-1" data-testid={`unscheduled-chip-${p.id}`}>
                <Plus className="w-3 h-3" />{p.name}
              </button>
            ))}
          </div>
        </div>
      )}
      {doubleBooked.length > 0 && (
        <div data-testid="double-booked-panel">
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-red-400" />
            <span className="text-white font-semibold text-sm">On two jobs the same day</span>
            <span className="text-xs px-2 py-0.5 rounded-full bg-red-500/15 text-red-300 border border-red-500/30" data-testid="double-booked-count">{doubleBooked.length}</span>
          </div>
          <div className="space-y-1 mt-2">
            {doubleBooked.map(d => (
              <p key={`${d.date}-${d.id}`} className="text-xs text-gray-300" data-testid={`double-booked-row-${d.id}-${d.date}`}>
                <span className="text-white font-medium">{d.name}</span> · {format(new Date(d.date + 'T00:00:00'), 'EEE d MMM')} · {d.refs.join(' + ')}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
